import { Box } from '@mui/material';
import React from 'react'

const FieldWrapper = ({ children }) => (
  <Box sx={{ width: "100%", minWidth: 230 }}>
    {children}
  </Box>
);

export default FieldWrapper;